import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ShippingTerm, ShippingTermCreate, ShippingTermFilter } from '../data/shippingTerm';

export function createShippingTermService(client: AxiosInstance) {
  return createCrudService<ShippingTerm, ShippingTermCreate, ShippingTermFilter>(
    client,
    '/master-data/ShippingTerm',
    'id',
  );
}

export type ShippingTermService = CrudService<ShippingTerm, ShippingTermCreate, ShippingTermFilter>;
